export var GameCategoryType;
(function (GameCategoryType) {
    GameCategoryType[GameCategoryType["SPORT_LOTTERY"] = 1] = "SPORT_LOTTERY";
    GameCategoryType[GameCategoryType["LIVE_GAME"] = 2] = "LIVE_GAME";
    GameCategoryType[GameCategoryType["LOTTERY"] = 3] = "LOTTERY";
    GameCategoryType[GameCategoryType["CARD_GAME"] = 4] = "CARD_GAME";
    GameCategoryType[GameCategoryType["VIDEO_GAME"] = 5] = "VIDEO_GAME";
    GameCategoryType[GameCategoryType["FISH_CATCHER"] = 6] = "FISH_CATCHER";
    GameCategoryType[GameCategoryType["ESPORT"] = 7] = "ESPORT";
})(GameCategoryType || (GameCategoryType = {}));
//# sourceMappingURL=GameCategoryType.js.map